import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '../../../common/Button/Button'
import { ReactModal } from '../../../common/ReactModal/ReactModal'
import { polyglot, patientsDatabase } from '../../../../index'
import update from 'react-addons-update'
import { Field } from '../../../common/Field/Field'
import { Renderer } from '../../../common/Renderer/Renderer'
import { Timeline } from '../../../common/Timeline/Timeline'
import moment from 'moment/moment'
import { Panel } from '../../../common/Panel/Panel'

const dateFormat = {
  standartData: 'YYYY-MM-DD'
}

export default class Development extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      modalIsOpen: false,
      elements: {}
    }
    this.toggleModal = this.toggleModal.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.updateState = this.updateState.bind(this)
    this.renderEvolutionTree = this.renderEvolutionTree.bind(this)
  }
  toggleModal () {
    this.setState({
      modalIsOpen: !this.state.modalIsOpen
    })
  }

  handleSubmit (e) {
    e.preventDefault()
    this.toggleModal()
    const data = this.state.elements
    const developmentsRef = patientsDatabase.child(this.props.patientKey).child('data').child('developments')
    developmentsRef.push(data)
  }

  updateState (name, value) {
    let updated
    if (value === '') {
      updated = update(this.state.elements, {
        [name]: {$set: null}
      })
    } else {
      updated = update(this.state.elements, {
        [name]: {$set: value}
      })
    }
    this.setState({
      elements: updated
    })
  }

  getDaysDifferenceForDevelopment (developmentDate, rangeStart, rangeEnd) {
    return Math.min(Math.abs(developmentDate.diff(rangeEnd, 'days')), Math.abs(developmentDate.diff(rangeStart, 'days')))
  }

  getPeriodOffType (developmentDate, rangeStart, rangeEnd) {
    if (developmentDate.diff(rangeStart, 'days') >= developmentDate.diff(rangeEnd, 'days')) {
      return 'earlier'
    } else {
      return developmentDate.diff(rangeEnd, 'days')
    }
  }

  getStateForDays (daysDifference, rangeDays, testing) {
    const percentageFromRange = (daysDifference / rangeDays) * 100
    if (percentageFromRange <= 2) {
      return 'green'
    } else if (percentageFromRange > 2 && percentageFromRange <= 5) {
      return 'yellow'
    } else if (percentageFromRange > 5 && percentageFromRange <= 7) {
      return 'orange'
    } else if (percentageFromRange > 7 && percentageFromRange <= 10) {
      return 'red'
    } else if (percentageFromRange > 10) {
      return 'purple'
    }
  }

  getStateForDevelopment (development) {
    let state = { status: '', type: 'late', ammount: 2 }
    Object.keys(this.props.developmentsData).forEach(key => {
      const object = this.props.developmentsData[key]
      if (object.type === development.parameter) {
        const rangeStart = moment(new Date(this.props.patient.birthDate)).add(moment.duration(object.range.start))
        const rangeEnd = moment(new Date(this.props.patient.birthDate)).add(moment.duration(object.range.end))
        const developmentDate = moment(new Date(development.date))
        if (developmentDate.isBetween(rangeStart, rangeEnd)) {
          state = 'green'
        } else {
          const daysDifference = this.getDaysDifferenceForDevelopment(developmentDate, rangeStart, rangeEnd)
          const developmentRangeDurationInDays = rangeEnd.diff(rangeStart, 'days')
          state = this.getStateForDays(daysDifference, developmentRangeDurationInDays, development.parameter)
        }
      }
    })
    return state
  }

  getDataForTimeline () {
    const data = []
    const patientDevelopments = this.props.patient.data && this.props.patient.data['developments']
    if (patientDevelopments) {
      Object.keys(patientDevelopments).forEach(key => {
        const development = patientDevelopments[key]
        data.push({text: polyglot.t(`developmentInsertion.parameter.${development.parameter}`),
          date: development.date,
          state: this.getStateForDevelopment(development)})
      })
    }
    data.sort(function (a, b) {
      if (a.date > b.date) {
        return 1
      } else if (a.date < b.date) {
        return -1
      } return 0
    })
    return data
  }

  renderEvolutionTree () {
    const dataForTimeline = this.getDataForTimeline().reverse()
    return <Timeline startDate={this.props.patient.birthDate} data={dataForTimeline} />
  }

  renderDevelopments () {
    const data = this.props.patient.data && this.props.patient.data.hasOwnProperty('developments') ? this.props.patient.data['developments'] : undefined
    return <Renderer data={data} noDataMessage={polyglot.t('staticFields.commonFields.noData')}>
      <div>
        {this.renderEvolutionTree()}
      </div>
    </Renderer>
  }

  renderModal () {
    return <ReactModal name={polyglot.t('staticFields.medicalData.development.newDevelopment')} toggleModal={this.toggleModal} modalIsOpen={this.state.modalIsOpen}>
      <div className='form-horizontal'>
        <form onSubmit={e => this.handleSubmit(e)}>
          {this.props.insertionConfiguration.elements.map(element => {
            return <Field getValue={this.updateState}
              minDateForCalendar={this.props.patient.birthDate}
              maxDateForCalendar={moment().format(dateFormat.standartData)}
              required={!element.optional}
              key={element.label}
              label={element.label}
              elements={element.elements}
              name={element.name}
              type={element.type} />
          })}
          <Button type='submit' text={polyglot.t('staticFields.commonFields.save')} buttonType='btn-primary btn-block' />
        </form>
      </div>
    </ReactModal>
  }
  render () {
    return <div>
      <Panel
        heading={polyglot.t('staticFields.medicalData.development.title')}
        disableCollapse={false}
        rightHeader={<Button
          buttonType='btn btn-success btn-sm'
          text={polyglot.t('staticFields.medicalData.development.addNewDevelopment')}
          type={'button'}
          onClick={this.toggleModal} />}>
        {this.renderDevelopments()}
      </Panel>
      {/* <SectionTitle */}
      {/* reduceTopMargin */}
      {/* title={polyglot.t('staticFields.medicalData.development.title')} */}
      {/* size={'h4'} */}
      {/* rightField={<Button */}
      {/* buttonType='btn btn-success btn-sm' */}
      {/* text={polyglot.t('staticFields.medicalData.development.addNewDevelopment')} */}
      {/* type={'button'} */}
      {/* onClick={this.toggleModal} />} /> */}

      {this.renderModal()}
    </div>
  }
}

Development.propTypes = {
  insertionConfiguration: PropTypes.object.isRequired,
  developmentsData: PropTypes.array.isRequired,
  patientKey: PropTypes.string.isRequired,
  patient: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/components/general/Consultations/Development/Development.js